<div class="block--bg-wrapper booking-summary">
    <div *ngIf="(estimatedPrice$ | async) != infinity">
        <h3 class="title-bg-wrapper">{{'BOOKING_SUMMARY_SPECIFY_TITLE' | translate}}</h3>
        <h2 class="title-bg-wrapper summary-price">
            {{(estimatedPrice$ | async) | moneyFormat}} {{appStartupService.getCurrency() | translate}}
        </h2>
    </div>

    <div class="block block--wrap">
        <div class="summary-module-area">
            <div class="summary-module-area__btn">
                <button class="btn btn--maximal btn--primary" type="submit" *ngIf="!loading" [disabled]="!isValidated"
                    (click)="submitBooking()">{{'BOOKING_SUMMARY_SPECIFY_CONFIRM' | translate}}</button>
                <button class="btn btn--maximal btn--primary" *ngIf="loading" [disabled]="true">
                    {{ 'BUTTON_LOADER_TEXT' | translate }}
                </button>
            </div>
            <div class="summary-module-area__btn margin-top-30">
                <ridango-ui-back-button [routerLink]="'/book-a-ride' | localize" [showArrow]=false>
                    {{'BOOKING_SUMMARY_SPECIFY_BACK_LINK' | translate}}
                </ridango-ui-back-button>
            </div>
        </div>
    </div>
</div>
